(() => {
  function getValue(wrapper) {
    const el = wrapper && wrapper.querySelector('.hc-swatch-value');
    return el ? el.textContent.trim() : '';
  }

  function setCurrent(container, value) {
    const el = container.querySelector('.hc-swatch-value-current');
    if (el) el.textContent = value || '';
  }

  function getActiveValue(container) {
    const active = container.querySelector('.hc-swatch-wrapper.hc-swatch-active');
    return getValue(active);
  }

  function setActive(container, swatch) {
    container.querySelectorAll('.hc-swatch-wrapper').forEach((item) => {
      item.classList.remove('hc-swatch-active');
    });

    swatch.classList.add('hc-swatch-active');
    setCurrent(container, getValue(swatch));
  }

  function init(container) {
    const list = container.querySelector('.hc-related-products');
    if (!list || list.dataset.hcBound === '1') return;

    list.dataset.hcBound = '1';
    setCurrent(container, getActiveValue(container));

    list.addEventListener('mouseover', (event) => {
      const swatch = event.target.closest('.hc-swatch-wrapper');
      if (!swatch || !list.contains(swatch)) return;

      const value = getValue(swatch);
      if (value) setCurrent(container, value);
    });

    list.addEventListener('mouseout', (event) => {
      const swatch = event.target.closest('.hc-swatch-wrapper');
      if (!swatch || !list.contains(swatch)) return;

      const to = event.relatedTarget;
      if (to && swatch.contains(to)) return;
      setCurrent(container, getActiveValue(container));
    });

    list.addEventListener('mousedown', (event) => {
      const link = event.target.closest('.hc-swatch-wrapper a');
      if (!link || !list.contains(link)) return;

      const swatch = link.closest('.hc-swatch-wrapper');
      if (swatch) setActive(container, swatch);
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('.hc-related-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
